export const LIVE_QUESTION_GET = 'LIVE_QUESTION_GET';
export const LIVE_QUESTION_GET_SUCCESS = 'LIVE_QUESTION_GET_SUCCESS';
export const LIVE_QUESTION_GET_FAILED = 'LIVE_QUESTION_GET_FAILED';
export const LIVE_QUESTION_UPDATE = 'LIVE_QUESTION_UPDATE';
export const LIVE_QUESTION_UPDATE_SUCCESS = 'LIVE_QUESTION_UPDATE_SUCCESS';
export const LIVE_QUESTION_UPDATE_FAILED = 'LIVE_QUESTION_UPDATE_FAILED';
export const LIVE_QUESTION_RESET = 'LIVE_QUESTION_RESET';
export const LIVE_NEXT_QUESTION = 'LIVE_NEXT_QUESTION';
export const LIVE_QUESTION_CHANGE = 'LIVE_QUESTION_CHANGE';
export const LIVE_QUESTION_ON_CHANGE = 'LIVE_QUESTION_ON_CHANGE';